import { Provider, SupabaseClient } from "@supabase/supabase-js";
import { TODO } from "./utilities";
import { JWTPayload } from "jose";

export interface SupabaseJWTPayload extends JWTPayload {
  email?: string;
  email_verified?: boolean;
  phone?: string;
  role?: string;
  app_metadata?: {
    provider?: string;
    providers?: string[];
    [key: string]: unknown;
  };
  user_metadata?: {
    [key: string]: unknown;
  };
}

export type AuthProviders = Provider;
export interface Localization {
  // [key: string]: I18nVariables
  ["en"]: I18nVariables;
}

// export type SocialLayout = 'horizontal' | 'vertical'
export enum SocialLayouts {
  "horizontal",
  "vertical",
}
export type SocialLayout = keyof typeof SocialLayouts;
export type SocialButtonSize = "tiny" | "small" | "medium" | "large" | "xlarge";

export type ViewSignIn = "sign_in";
export type ViewSignUp = "sign_up";
export type ViewMagicLink = "magic_link";
export type ViewForgottenPassword = "forgotten_password";
export type ViewUpdatePassword = "update_password";

export type ViewType =
  | ViewSignIn
  | ViewSignUp
  | ViewMagicLink
  | ViewForgottenPassword
  | ViewUpdatePassword;

export interface ViewsMap {
  [key: string]: ViewType;
}

export type RedirectTo = undefined | string;

export interface BaseAuth {
  supabaseClient: TODO; // SupabaseClient;
  socialLayout?: SocialLayout;
  providers?: Provider[];
  view?: ViewType;
  redirectTo?: RedirectTo;
  onlyThirdPartyProviders?: boolean;
  magicLink?: boolean;
  showLinks?: boolean;
  linkUrl?: string;

  /**
   * This will toggle on the dark variation of the theme
   */
  dark?: boolean;
  /**
   * Override the labels and button text
   */
  localization?: {
    variables?: I18nVariables;
  };
  theme?: "default" | string;
}

export type I18nVariables = {
  shared?: {
    link_prompt?: string;
    link_text?: string;
    terms_text?: string;
    terms_link?: string;
  };
  sign_up?: {
    title?: string;
    description?: string;
    email_label?: string;
    password_label?: string;
    email_input_placeholder?: string;
    password_input_placeholder?: string;
    button_label?: string;
    loading_button_label?: string;
    social_provider_text?: string;
    link_text?: string;
    confirmation_title?: string;
    confirmation_text?: string;
  };
  sign_in?: {
    title?: string;
    description?: string;
    email_label?: string;
    password_label?: string;
    email_input_placeholder?: string;
    password_input_placeholder?: string;
    button_label?: string;
    loading_button_label?: string;
    social_provider_text?: string;
    link_text?: string;
  };
  magic_link?: {
    title?: string;
    description?: string;
    email_input_label?: string;
    email_input_placeholder?: string;
    button_label?: string;
    loading_button_label?: string;
    social_provider_text?: string;
    link_text?: string;
    confirmation_title?: string;
    confirmation_text?: string;
  };
  forgotten_password?: {
    title?: string;
    description?: string;
    email_label?: string;
    password_label?: string;
    email_input_placeholder?: string;
    button_label?: string;
    loading_button_label?: string;
    link_text?: string;
    confirmation_title?: string;
    confirmation_text?: string;
  };
  update_password?: {
    title?: string;
    description?: string;
    password_label?: string;
    password_input_placeholder?: string;
    button_label?: string;
    loading_button_label?: string;
    confirmation_title?: string;
    confirmation_text?: string;
  };
};
